module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/conscientiousness/9a5eed21b24a4d6c07865a39c5452c05.png";